import { useTranslations } from 'next-intl';

interface DialogLeaveProps {
	closeForm: () => void;
	closeDialog: () => void;
	isShow: boolean;
}
export const DialogLeave = ({ closeForm, closeDialog, isShow }: DialogLeaveProps) => {
	const t = useTranslations('General');
	return (
		<div className="survey-modal" data-open={isShow}>
			<div className="survey-dialog survey-dialog-leave">
				<div className="survey-dialog__wrap">
					<div className="survey-dialog__title">{t('lbl_SabaSurveyLeaveTemporarily')}</div>
					<div className="survey-dialog__text"
						dangerouslySetInnerHTML={{ __html: t.raw('lbl_SabaSurveyKeepContent') }}
					>
					</div>
					<div className="survey-dialog__footer">
						<div className="survey-btn-outline"
							onClick={closeForm}
						>{t('lbl_SabaSurveyLeave')}
						</div>
						<div className="survey-btn-cancel"
							onClick={closeDialog}
						>{t('lbl_SabaSurveyContinue')}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}